"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const grid_1 = __importDefault(require("components/templates/grid"));
const stockpile_style_1 = __importDefault(require("../stockpile.style"));
const stockpile_action_1 = __importDefault(require("../stockpile.action"));
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const modal_1 = require("components/molecules/modal");
const stockpile_column_1 = require("../stockpile.column");
const StockpileHistory = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { mutationMode, dataHistory, dataItem, isLoading, onCallWebSocket, isPenalty, dataStatesHistory, dataDumptruck } = (0, store_1.useAppSelector)((state) => state.stockpile);
    const { configurationCheckPointData: dataPos } = (0, store_1.useAppSelector)((state) => state.stockpilePos);
    (0, react_1.useEffect)(() => {
        if (isLoading) {
            dispatch(stockpile_action_1.default.getDataHistory(dataStatesHistory));
        }
    }, [isLoading]);
    const onClickHandle = (event) => {
        dispatch(stockpile_action_1.default.onClickMutation({
            mutationMode: 'details',
            dataItemHistory: event.dataItem,
            onCallWebSocket,
            isPenalty,
            dataDumptruck
        }));
    };
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { skip: types === 'page' ? (val - 1) * dataStatesHistory.take : 0, take: types === 'take' ? val : dataStatesHistory.take, filter: {
                logic: 'and',
                filters: [{
                        field: 'pos_id',
                        operator: 'uuid',
                        value: dataPos.checkpoint_id
                    }]
            } });
        dispatch(stockpile_action_1.default.onDataStateChangeHistory(newDataStates));
    };
    return ((0, jsx_runtime_1.jsx)(modal_1.Modal, Object.assign({ appTheme: appTheme, modalTitle: 'History', show: mutationMode === 'history', style: stockpile_style_1.default.modalContainer(appTheme), handleClose: () => {
            dispatch(stockpile_action_1.default.onClickMutation({
                mutationMode: false, onCallWebSocket, isPenalty: false, dataDumptruck, dataItem
            }));
        } }, { children: (0, jsx_runtime_1.jsx)(grid_1.default, { pageable: true, sortable: false, cardGrid: false, filterable: false, dataGrid: dataHistory, style: stockpile_style_1.default.gridHeight, sort: dataStatesHistory.sort, dataStates: dataStatesHistory, columns: stockpile_column_1.stockpileHistoryColumnProps, scrollable: dataStatesHistory.scrollable, onRowClick: (event) => onClickHandle(event), onPageChange: v => onDataStateChange('page', v), onTakeChange: v => onDataStateChange('take', v) }) })));
};
exports.default = StockpileHistory;
